import Vue from 'vue';

// 指令
Vue.directive('button', {
    bind: (el, binding, vnode) => {
        // yan
        let attrBtn = '';
        let class1 = ''; // 按钮的状态或是有背景色或无背景色
        let class2 = 'keep-button'; // 按钮的默认高度
        let class3 = ''; // 圆角
        if (binding.value) {
            if (binding.value.type || binding.value.state) {
                class1 = 'keep-' +
                // 按钮的类型
                (binding.value.type || '') +
                // 是有背景色还是无背景色的按钮
                (binding.value.state || '');
            }
            // 默认按钮高度
            if (binding.value.btnType) {
                class2 = class2 + '-' + binding.value.btnType;
            }
            if (binding.value.shape) {
                class3 = 'keep-' + binding.value.shape;
            }
        }
        attrBtn = class1 + ' ' +
        // 增加按钮圆角的class样式''
        class3 + ' ' +
        // 是底部按钮还是卡片按钮
        class2 + ' ' +
        (el.className || '');
        el.setAttribute('class', attrBtn);
    },
    inserted: (el, binding, vnode) => {
        // ueeueuueu
    },
});
